import React from 'react';
import { bool, func } from 'prop-types';

import ImageSystemMaintenance from '@assets/Image/DayTrading/SystemMaintenance.svg';

import { Container, Row, Col, Button, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const PopUpMtSuspended = (props) => {
  const { show, onHide } = props;

  return (
    <PopUpCenterV2 size="md" show={show} onHide={onHide} data-testid="popup-mtSuspended">
      <img src={ImageSystemMaintenance} alt="account-suspended" />
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          Margin Trading Tidak Bisa Digunakan
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          Hubungi Relationship Manager Anda untuk mendapatkan akses ke Margin Trading.
        </Typography>
      </Container>
      <Row gutters={8} align="between">
        <Col>
          <Button fluid variant="primary" size="lg" onClick={onHide}>
            Mengerti
          </Button>
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpMtSuspended.propTypes = {
  show: bool,
  onHide: func,
};

PopUpMtSuspended.defaultProps = {
  show: false,
  onHide: () => {},
};

export default PopUpMtSuspended;
